<div class="layout-topbar">
  <div class="layout-topbar-start">
    <a class="layout-topbar-logo" routerLink="/">
      <img style="height: 4rem; max-height: 100%;" src="assets/images/logo-bg.png" alt="eArhiv" />
    </a>
    <a #menuButton class="layout-menu-button" (click)="onMenuButtonClick()" pRipple>
      <i class="pi pi-chevron-right"></i>
    </a>

    <a #mobileMenuButton class="layout-topbar-mobile-button" (click)="onMobileTopbarMenuButtonClick()" pRipple>
      <i class="pi pi-ellipsis-v"></i>
    </a>
  </div>

  <div class="layout-topbar-end">
    <div class="layout-topbar-actions-start">
      <!--            <p-megaMenu [model]="model" styleClass="layout-megamenu"></p-megaMenu>-->
    </div>
    <div class="layout-topbar-actions-end">
      <ul class="layout-topbar-items">
        <!-- GAP-UC-43: settings gear (zupčanik), placed immediately BEFORE the notifications bell (REQ-001/002/020) -->
        <li>
          <a id="uiPrefsGearButton" role="button" tabindex="0"
             aria-haspopup="dialog" aria-label="Postavke prikaza"
             pRipple pTooltip="Postavke prikaza"
             (click)="onOpenUiPrefs($event)"
             (keydown.enter)="onOpenUiPrefs($event)"
             (keydown.space)="onOpenUiPrefs($event)">
            <i class="pi pi-cog" aria-hidden="true"></i>
          </a>
          <p-overlayPanel #uiPrefsOverlay [dismissable]="true" [showCloseIcon]="false"
                          styleClass="ui-prefs-overlay">
            <ng-template pTemplate="content">
              <app-ui-preferences-panel (closed)="uiPrefsOverlay.hide()"></app-ui-preferences-panel>
            </ng-template>
          </p-overlayPanel>
        </li>
        <li>
          <app-notification-overlay />
        </li>
				<li class="layout-topbar-search">
					<button
					  pButton
						pRipple
						type="button"
            pStyleClass="@next"
            enterClass="ng-hidden"
            enterActiveClass="px-scalein"
            leaveToClass="ng-hidden"
            leaveActiveClass="px-fadeout"
            [hideOnOutsideClick]="true"
						*ngIf="user$ | async as user"
						class="p-button-rounded p-button-text text-gray-200"
          >
						<span>{{user.firstName}} {{user.lastName}}</span>
					</button>
          <div class="ng-hidden">
            <ul class="list-none p-0 m-0">
              <li>
                <a
                  class="cursor-pointer flex align-items-center py-2 hover:surface-hover transition-duration-150 transition-all px-3 py-2"
                  pRipple (click)="onOpenMojaInititucija()">
                  <i class="pi pi-cog mr-2"></i>
                  <span>Moja institucija</span>
                </a>
              </li>
              <li>
                <a
                  class="cursor-pointer flex align-items-center py-2 hover:surface-hover transition-duration-150 transition-all px-3 py-2"
                  pRipple (click)="navigate('/user-profile')">
                  <i class="pi pi-cog mr-2"></i>
                  <span>Promjena zaporke</span>
                </a>
              </li>
              <li>
                <a
                  class="cursor-pointer flex align-items-center py-2 hover:surface-hover transition-duration-150 transition-all px-3 py-2"
                  pRipple (click)="logout()">
                  <i class="pi pi-power-off mr-2"></i>
                  <span>Odjava</span>
                </a>
              </li>
            </ul>
          </div>

        </li>
<!--        <li>-->
<!--          <a (click)="onRightMenuButtonClick()" pRipple>-->
<!--            <i class="pi pi-arrow-left"></i>-->
<!--          </a>-->
<!--        </li>-->
      </ul>
    </div>
  </div>
</div>
